module.exports = __webpack_public_path__ + "static/sendeo-campaign-summary-screenshot-7266792ec7726dd25deb9b77201a1e27.png";